export default "__VITE_ASSET__18g$oT9N__"